exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".line[data-v-e1d0f770]{text-align:center}", ""]);

// exports
